var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrash = function SvgTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#trash_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#18181B",
    d: "M7.875.7C8.938.7 9.8 1.562 9.8 2.625v.31q.835.08 1.656.209a.526.526 0 0 1-.162 1.038l-.104-.017-.589 7.363c-.08 1-.915 1.772-1.919 1.772H5.317a1.925 1.925 0 0 1-1.918-1.772l-.59-7.363-.103.017a.526.526 0 0 1-.162-1.038 29 29 0 0 1 1.656-.21v-.309C4.2 1.562 5.062.7 6.125.7zM5.45 4.676a.75.75 0 0 0-.72.78l.21 5.25a.75.75 0 1 0 1.499-.061l-.21-5.25a.75.75 0 0 0-.78-.72m3.098 0a.75.75 0 0 0-.779.719l-.21 5.25a.75.75 0 0 0 1.498.06l.21-5.25a.75.75 0 0 0-.719-.78M6.125 1.75a.875.875 0 0 0-.875.875v.228a29 29 0 0 1 3.5 0v-.228a.875.875 0 0 0-.875-.875z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "trash_svg__a",
    width: 9.801,
    height: 13.1,
    x: 2.1,
    y: 0.7,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_199_8973"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_199_8973",
    result: "shape"
  })))));
};
export default SvgTrash;